<script>
    import { getContext, onDestroy } from "svelte";
    import { setSort } from "./table";
    export let css = "";
    export let path;
    export let caseSensitive = undefined;
    export let asDate = undefined;
    export let asNumber = undefined;
    export let useSlots = false;

    const tableStore = getContext("svelte-simple-table");

    let sortedAsc = false;
    let sortedDesc = false;
    let state;

    const unsub = tableStore.subscribe((x) => (state = x));
    onDestroy(() => unsub());

    $: {
        // If state changes, update if we are sorted or not.
        if (state && state.sorting && state.sorting.by === path) {
            sortedAsc = state.sorting.asc;
            sortedDesc = !state.sorting.asc;
        } else {
            sortedAsc = false;
            sortedDesc = false;
        }
    }

    const sort = () => {
        const sortOpts = {
            caseSensitive: caseSensitive,
            asDate: asDate,
            asNumber: asNumber,
        };
        setSort(tableStore, path, !sortedAsc, sortOpts);
    };
</script>

<div class={css} on:click={sort}>
    <slot />
    {#if useSlots}
        {#if !sortedAsc && !sortedDesc}<slot name="sort" />{/if}
        {#if sortedAsc}<slot name="sortAsc" />{/if}
        {#if sortedDesc}<slot name="sortDesc" />{/if}
    {:else}
        {#if !sortedAsc && !sortedDesc && state.sortIconCss}{@html state.sortIconCss}
        {/if}
        {#if sortedAsc && state.sortIconAscCss}{@html state.sortIconAscCss}
        {/if}
        {#if sortedDesc && state.sortIconDescCss}{@html state.sortIconDescCss}
        {/if}
    {/if}
</div>
